(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-slideshow-v-1-0"] && !Shopify.designMode) return;
  try {
    
  // Slideshow component
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.slides = this.querySelectorAll('.ss-slideshow__slide');
      if (this.slides.length <= 1) return;

      this.currentSlideIndicator = this.querySelector('.ss-current-slide-indicator');
      this.currentSlideIndex = this.dataset.activeSlide;
      this.counterControls = this.querySelectorAll('.ss-slideshow-controls__link');

      this.nextControl = this.querySelector('.ss-slideshow-control--next');
      this.previousControl = this.querySelector('.ss-slideshow-control--previous');

      if (this.getAttribute('data-autoplay') === 'true') {
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed) * 1000;
        this.isAutoplayButtonSetToPlay = true;
        this.setAutoPlay();
      }

      this.initButtons();
    }

    initButtons() {
      this.nextControl.addEventListener('click', () => {
        this.updateSlideshow('next');
        this.resetAutoPlay();
      });

      this.previousControl.addEventListener('click', () => {
        this.updateSlideshow('previous');
        this.resetAutoPlay();
      });

      this.counterControls.forEach((control) => {
        control.addEventListener('click', () => {
          if (this.currentSlideIndex == control.dataset.slideNumber) return;
          this.updateSlideshow(control.dataset.slideNumber);
          this.resetAutoPlay();
        });
      });
    }

    updateSlideshow(target = 'next') {
      let nextSlideIndex = 0;
      let transitionDirection = target;

      switch (target) {
        case 'next':
          nextSlideIndex = parseInt(this.dataset.activeSlide) + 1;
          break;
        case 'previous':
          nextSlideIndex = parseInt(this.dataset.activeSlide) - 1;
          break;
        default:
          nextSlideIndex = target;
          transitionDirection = nextSlideIndex > this.dataset.activeSlide ? 'next' : 'previous';
          break;
      }

      if (nextSlideIndex < 0) {
        nextSlideIndex = this.slides.length - 1;
      } else if (nextSlideIndex >= this.slides.length) {
        nextSlideIndex = 0;
      }

      this.slideTransition(this.slides[this.dataset.activeSlide], this.slides[nextSlideIndex], transitionDirection);
      this.updateControls(nextSlideIndex);
      this.dataset.activeSlide = nextSlideIndex;
      this.currentSlideIndex = nextSlideIndex;
    }

    slideTransition(currentSlide, nextSlide, transitionDirection) {
      const slideshowControls = this.querySelectorAll('.ss-slideshow-control');
      slideshowControls.forEach((control) => {
        control.setAttribute('disabled', 'true');
      });

      currentSlide.addEventListener('animationend', (event) => {
        if (event.animationName.includes('ssSlideIn')) return;

        // Hide slides & reset transitions
        this.slides.forEach((slide) => {
          slide.setAttribute('aria-hidden', 'true');
          slide.classList.remove(`ss-slide--transition-out-${transitionDirection}`);
        });

        // Set new slide to active
        nextSlide.setAttribute('aria-hidden', 'false');
        nextSlide.classList.remove(`ss-slide--${transitionDirection}`);
        slideshowControls.forEach((control) => {
          control.removeAttribute('disabled');
        });
      });

      // Start slide transition
      currentSlide.classList.add(`ss-slide--transition-out-${transitionDirection}`);
      nextSlide.classList.add(`ss-slide--${transitionDirection}`);
    }

    updateControls(newSlideIndex) {
      // If we have a current slide indicator (i.e. 2/3), update it
      if (this.currentSlideIndicator) {
        this.currentSlideIndicator.innerText = `${newSlideIndex + 1}/${this.slides.length}`;
        return;
      }

      this.counterControls.forEach((control) => {
        control.classList.remove('ss-slideshow-controls__link--active');
      });
      this.counterControls[newSlideIndex].classList.add('ss-slideshow-controls__link--active');
    }

    resetAutoPlay() {
      if (this.isAutoplayButtonSetToPlay) {
        this.play();
      }
    }

    /* Handle autoplay */
    setAutoPlay() {
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));

      this.sliderAutoplayButton = this.querySelector('.ss-slideshow-control--autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.isAutoplayButtonSetToPlay = true;
      this.play();
    }

    autoPlayToggle() {
      this.togglePlayButtonState(this.isAutoplayButtonSetToPlay);
      this.isAutoplayButtonSetToPlay ? this.pause() : this.play();
      this.isAutoplayButtonSetToPlay = !this.isAutoplayButtonSetToPlay;
    }

    togglePlayButtonState(pauseAutoplay) {
      this.sliderAutoplayButton.classList.toggle('ss-slideshow-control--autoplay--paused', pauseAutoplay);
      pauseAutoplay
        ? this.sliderAutoplayButton.setAttribute('aria-label', 'Play slideshow')
        : this.sliderAutoplayButton.setAttribute('aria-label', 'Pause slideshow');
    }

    play() {
      this.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
      this.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }

    autoRotateSlides() {
      this.updateSlideshow('next');
    }

    focusOutHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay && !focusedOnAutoplayButton) this.play();
    }

    focusInHandling(event) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);

      if (this.isAutoplayButtonSetToPlay) {
        focusedOnAutoplayButton ? this.play() : this.pause();
      }
    }
  }

  if (!customElements.get('ss-slideshow-component')) {
    customElements.define('ss-slideshow-component', SlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
